<template lang="pug">
  .notification
    .notification__header
      .notification__title {{ payload.subject }}
      .notification__date {{ hours }}
    .notification__body
      p.notification__content {{ payload }}
</template>

<script>
import notification from '@/mixins/notification.mixin';

export default {
  name: 'OrderNotRead',
  mixins: [notification]
};
</script>
